import { Box, Grid, Typography, Button } from "@mui/material";
import styles from "../Information/Information.module.scss";
import CONSTANTS from "../../config/constants.json";

const Awards = () => {
  return (
    <Box className={styles.AwardsTotalContainer}>
      <Typography className={styles.mainHeading}>Awards</Typography>
      {/* {AwardsInfo.map((info, i) => ( */}
      <div className={styles.mainCardContainer}>
        <div className={styles.singleCard}>
          <a
            href={CONSTANTS.DOMAIN_URL + "/hints/content/html/2016/cer2.pdf"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/award1.png" className={styles.awardImage} />
          </a>
          <div className={styles.awardDetails}>
            <Typography className={styles.givenByDetails}>
              Resolution from the California State Assembly - Given by
              California Assembly Woman, Catherine Baker
            </Typography>
            <Typography className={styles.awardSummary}>
              California Assembly Woman Catherine Baker was at our temple on
              July 9th to give away the Resolution from the California State
              Assembly congratulating HCCC for its 30th anniversary and for our
              services to the community at large. It was indeed a proud moment
              for HCCC! Thank you Catherine Baker!
            </Typography>
            <div>
              <a
                href={
                  CONSTANTS.DOMAIN_URL + "/hints/content/html/2016/cer2.pdf"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className={styles.awardButton}>
                  <pre>PDF to view the award</pre>
                </Button>
              </a>
            </div>
          </div>
        </div>
        <div className={styles.singleCard}>
          <a
            href={
              CONSTANTS.DOMAIN_URL + "/hints/content/html/2016/yogaday-cer.pdf"
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/award2.png" className={styles.awardImage} />
          </a>
          <div className={styles.awardDetails}>
            <Typography className={styles.givenByDetails}>
              Proclamation from the city of Livermore - Given by the mayor of
              Livermore, John Marchand
            </Typography>
            <Typography className={styles.awardSummary}>
              The City of Livermore declared July 9th as the Livermore Yoga day.
              They also presented this proclamation to the Shiva Vishnu temple
              on the occasion of the 30th anniversary of this institution that
              does yeoman service to the community. Livermore Mayor, John
              Marchand was present on the occasion.
            </Typography>
            <div>
              <a
                href={
                  CONSTANTS.DOMAIN_URL +
                  "/hints/content/html/2016/yogaday-cer.pdf"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className={styles.awardButton}>
                  <pre>PDF to view the award</pre>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* ))} */}
    </Box>
  );
};

export default Awards;
